import { ReactNode } from 'react';

import { Box, Button, SxProps } from '@mui/material';

import { ExtraButtons } from 'components/buttons';
import { ExtraButtonListProps } from 'components/buttons/ExtraButtons';
import { Bbar } from 'components/docked/Bbar';
import { ToggleFgAtivo } from 'components/fields';
import { useBreakpoints } from 'hooks/useBreakpoints';

export type BbarForm = {
    fgAtivo?: boolean | string;
    extraContent?: ReactNode;
    extraButtons?: ExtraButtonListProps | ExtraButtonListProps[];
    disableSaveBtn?: boolean;
    isLoading?: boolean;
    submitForm: () => Promise<any> | any;
    textSaveBtn?: string;
    sx?: SxProps;
};

export function BbarForm({ sx, submitForm, extraButtons, extraContent, fgAtivo, disableSaveBtn, isLoading, textSaveBtn = 'Salvar' }: BbarForm) {
    const { isUpMd } = useBreakpoints();

    return (
        <Bbar sx={sx}>
            {fgAtivo && isUpMd && <ToggleFgAtivo disabled={fgAtivo === 'disabled'} />}

            {extraContent}

            {isUpMd && <Box sx={{ flex: 1 }} />}

            {extraButtons && <ExtraButtons list={extraButtons} />}

            <Box sx={{ display: 'flex', gap: 1, width: { xs: '100%', md: 'auto' } }}>
                {fgAtivo && !isUpMd && <ToggleFgAtivo disabled={fgAtivo === 'disabled'} />}

                <Button
                    variant="contained"
                    loading={isLoading}
                    disabled={disableSaveBtn || isLoading}
                    onClick={submitForm}
                    sx={{ width: { xs: '100%', md: 'auto' } }}
                >
                    {textSaveBtn}
                </Button>
            </Box>
        </Bbar>
    );
}
